(function () {
    "use strict";

    let app = angular.module("app");

    app.service("permissionHelper", PermissionHelper);

    PermissionHelper.$inject = ["$rootScope", "$q", "request", "modalService"];

    function PermissionHelper($rootScope, $q, request, modalService) {

        var exports = {
            hasPermission: hasPermission,
            currentUserHasPermission: currentUserHasPermission
        };

        return exports;

        function currentUserHasPermission(rootScope, permissionKey) {
            //check if the logged in user has the given permission when we have currentUser in rootScope
            if (rootScope && rootScope.currentUser && rootScope.currentUser.permissionKeys)
                return rootScope.currentUser.permissionKeys.includes(permissionKey);
            return false;
        }

        function hasPermission(permissionKey) {
            //check if the logged in user has the given permission
            var deferred = $q.defer();
            request.get($rootScope.apiEndpoint + "/permissions/check/" + permissionKey).then(function (response) {
                deferred.resolve(response.data);

            }, function (e) {
                console.log(e);
                modalService.alert(e.data.message, "There was an error to check perission:");
                deferred.reject(e);
            });
            return deferred.promise;
        }
    }
})();
